import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TbFileUpload, TbPhone, TbRuler2 } from 'react-icons/tb';
import { Oval, ThreeDots } from 'react-loader-spinner';
import { Button, Card, Modal, Form } from 'react-bootstrap';
import { getTemplates, getTemplatesById } from '../store/whatsApp/wpThunks';
import { useDispatch, useSelector } from 'react-redux';
import { generateMeeting } from '../store/google/googleThunk';
import MeetModel from '../views/dashboard/app/meetModel';

// const ChatInput = ({
//     platform,
//     hasUserMessages,
//     canSendTemplate,
//     handleSendMessage,
//     handleSendTemplate,
//     setNewMessage,
//     senderId,
//     newMessage,
//     faqs,
//     // templates,
//     fbSendMessageloading,
//     igSendMessageloading,
//     waSendMessageloading,
//     handleFileUpload,
//     setShowEmojiPicker,
//     showEmojiPicker,
//     setShowQuickReply,
//     setFilteredQuickReplies,
// }) => {
//     let { profile } = useSelector((state) => state.userservice);

//     const dispatch = useDispatch()
//     const {
//         conversations,
//         currentConversation,
//         conversationDetails,
//         error,
//         message,
//         loading,
//         usergetTemplatesFullfill,
//         getTemplatesError,
//         getTemplatesByIdFullfill,
//         getTemplatesByIdError,
//     } = useSelector((state) => state.whatsapp);
//           const { generateMeetingLodading } = useSelector((state) => state.google);
//     const inputRef = useRef(null);
//     const inputFile = useRef(null);
//     const [showMeetModal, setShowMeetModal] = useState(false);
//     const [meetingLink, setMeetingLink] = useState('');
//     const [selectedTemplate, setSelectedTemplate] = useState('');
//     const [payloadValues, setPayloadValues] = useState([]);
//     const [templateData, setTemplateData] = useState("");
//     const [templates, setTemplates] = useState([]);
//     const [show4, setShow4] = useState(false);
//     const handleClose4 = () => setShow4(false);
//     const handleShow4 = () => setShow4(true);

//     console.log(templates, "templatestemplatestemplatestemplates")
//     useEffect(() => {
//         dispatch(getTemplates());
//     }, [platform === "whatsapp"]);

//     const onButtonClick = () => {
//         inputFile.current.click();
//     };

//     const getUpdatedText = () => {
//         if (!selectedTemplate) return "No Message Type Selected";

//         const template = templates.find((t) => t._id === selectedTemplate?._id);
//         if (!template?.components) return "No Message Type Selected";

//         const updatedComponents = template.components.map(
//             (component, compIndex) => {
//                 const textSegments = component.text?.split(/({{\d+}})/g) || []; // Split text by placeholders

//                 return textSegments.map((segment, index) => {
//                     const match = segment.match(/{{(\d+)}}/); // Match placeholders
//                     if (match) {
//                         const key = parseInt(match[1], 10); // Extract the placeholder number

//                         // Use payloadValues and default to currentName for {{1}} if applicable
//                         const value =
//                             key === 1
//                                 ? payloadValues[key] || "test"
//                                 : payloadValues[key] || "";
//                         return <strong key={`${compIndex}-${index}`}>{value}</strong>;
//                     }
//                     return segment; // Return plain text for non-placeholder segments
//                 });
//             }
//         );

//         // Flatten and return the updated components
//         return updatedComponents.flat();
//     };


//     const handleTemplateChange = async (event) => {
//         const templateId = event.target.value;
//         const selectedTemplate = templates.find(
//             (template) => template._id === templateId
//         );
//         setSelectedTemplate(selectedTemplate);
//         if (selectedTemplate) {
//             await fetchTemplateData(selectedTemplate._id);
//         }
//     };

//     const fetchTemplateData = (templateId) => {
//         dispatch(getTemplatesById(templateId));
//         setTemplateData(getTemplatesByIdFullfill?.template);
//         setTemplates(usergetTemplatesFullfill?.template);
//     };

//     useEffect(() => {
//         if (usergetTemplatesFullfill?.template?.length) {
//             setTemplates(usergetTemplatesFullfill?.template);
//             setSelectedTemplate(usergetTemplatesFullfill?.template[0]);
//             fetchTemplateData(usergetTemplatesFullfill?.template[0]?._id);
//         }
//     }, [usergetTemplatesFullfill]);

//     const handleGenerateMeeting = async () => {
//         try {
//             setShowMeetModal(true);
//             await dispatch(generateMeeting()).then((resp) => {
//                 console.log(resp, "respresp")
//                 const data = resp?.payload
//                 if (data?.status === 200) {
//                     setMeetingLink(data?.meetLink);
//                     setNewMessage(data?.meetLink)
//                 }
//             }).catch((e) => {
//                 console.log(e);
//             })
//         } catch (error) {
//             console.log('Error generating meeting:', error);
//         }
//     };

//     const handleCloseMeetModal = () => {
//         setShowMeetModal(false);
//         setMeetingLink('');
//     };
//     return (
//         <>
//             {hasUserMessages === false ? (
//                 <div className="alert alert-warning w-100 mb-0 d-flex align-items-center justify-content-between p-[14px]">
//                     <span>
//                         You can no longer reply to this conversation after 7 days of inactivity.
//                     </span>
//                 </div>
//             ) : platform === 'whatsapp' && canSendTemplate ? (
//                 <div className="d-flex align-items-center justify-content-center">
//                     <Button
//                         variant="primary"
//                         onClick={handleShow4}
//                         className="mt-1"
//                     >
//                         Send Message
//                     </Button>
//                 </div>
//             ) : (
//                 <form
//                     className="d-flex align-items-center"
//                     onSubmit={(e) => {
//                         e.preventDefault();
//                         handleSendMessage(platform);
//                         setNewMessage('');
//                     }}
//                 >
//                     <div className="chat-attagement d-flex">
//                         <Link
//                             to="#"
//                             className="d-flex align-items-center pe-3"
//                             onClick={() => setShowEmojiPicker(!showEmojiPicker)}
//                         >
//                             <svg
//                                 className="icon-24"
//                                 width="24"
//                                 viewBox="0 0 24 25"
//                                 fill="none"
//                                 xmlns="http://www.w3.org/2000/svg"
//                             >
//                                 <g clipPath="url(#clip0_156_599)">
//                                     <path
//                                         d="M20.4853 4.01473C18.2188 1.74823 15.2053 0.5 12 0.5C8.79469 0.5 5.78119 1.74823 3.51473 4.01473C1.24819 6.28119 0 9.29469 0 12.5C0 15.7053 1.24819 18.7188 3.51473 20.9853C5.78119 23.2518 8.79469 24.5 12 24.5C15.2053 24.5 18.2188 23.2518 20.4853 20.9853C22.7518 18.7188 24 15.7053 24 12.5C24 9.29469 22.7518 6.28119 20.4853 4.01473ZM12 23.0714C6.17091 23.0714 1.42856 18.3291 1.42856 12.5C1.42856 6.67091 6.17091 1.92856 12 1.92856C17.8291 1.92856 22.5714 6.67091 22.5714 12.5C22.5714 18.3291 17.8291 23.0714 12 23.0714Z"
//                                         fill="currentcolor"
//                                     ></path>
//                                     <path
//                                         d="M9.40398 9.3309C8.23431 8.16114 6.33104 8.16123 5.16136 9.3309C4.88241 9.60981 4.88241 10.0621 5.16136 10.3411C5.44036 10.62 5.89266 10.62 6.17157 10.3411C6.78432 9.72836 7.78126 9.7284 8.39392 10.3411C8.53342 10.4806 8.71618 10.5503 8.89895 10.5503C9.08171 10.5503 9.26457 10.4806 9.40398 10.3411C9.68293 10.0621 9.68293 9.60986 9.40398 9.3309Z"
//                                         fill="currentcolor"
//                                     ></path>
//                                     <path
//                                         d="M18.8384 9.3309C17.6688 8.16123 15.7655 8.16114 14.5958 9.3309C14.3169 9.60981 14.3169 10.0621 14.5958 10.3411C14.8748 10.62 15.3271 10.62 15.606 10.3411C16.2187 9.72836 17.2156 9.72831 17.8284 10.3411C17.9679 10.4806 18.1506 10.5503 18.3334 10.5503C18.5162 10.5503 18.699 10.4806 18.8384 10.3411C19.1174 10.0621 19.1174 9.60986 18.8384 9.3309Z"
//                                         fill="currentcolor"
//                                     ></path>
//                                     <path
//                                         d="M18.3335 13.024H5.6668C5.2723 13.024 4.95251 13.3438 4.95251 13.7383C4.95251 17.6243 8.11409 20.7859 12.0001 20.7859C15.8862 20.7859 19.0477 17.6243 19.0477 13.7383C19.0477 13.3438 18.728 13.024 18.3335 13.024ZM12.0001 19.3573C9.14366 19.3573 6.77816 17.215 6.42626 14.4525H17.574C17.2221 17.215 14.8566 19.3573 12.0001 19.3573Z"
//                                         fill="currentcolor"
//                                     ></path>
//                                 </g>
//                                 <defs>
//                                     <clipPath>
//                                         <rect
//                                             width="24"
//                                             height="24"
//                                             fill="white"
//                                             transform="translate(0 0.5)"
//                                         ></rect>
//                                     </clipPath>
//                                 </defs>
//                             </svg>
//                         </Link>
//                         <Link className="d-flex align-items-center pe-3">
//                             <TbFileUpload
//                                 style={{ fontSize: '25px' }}
//                                 onClick={() => onButtonClick()}
//                             />
//                         </Link>
//                         <Link
//                             className="d-flex align-items-center pe-3"
//                             onClick={handleGenerateMeeting}
//                             title="Generate Meeting Link"
//                         >
//                             <TbPhone
//                                 style={{ fontSize: '25px', cursor: 'pointer' }}
//                             />
//                         </Link>


//                         <input
//                             style={{ display: 'none' }}
//                             ref={inputFile}
//                             onChange={handleFileUpload}
//                             type="file"
//                         />
//                     </div>
//                     <input
//                         type="text"
//                         onChange={async (e) => {
//                             const value = e.target.value;
//                             setNewMessage(value);

//                             if (e.target.value.startsWith('/')) {
//                                 setShowQuickReply(true);
//                                 const filterText = value.slice(1);
//                                 const filteredReplies =
//                                     filterText.length > 0
//                                         ? faqs?.filter((faq) =>
//                                             faq?.title
//                                                 ?.toLowerCase()
//                                                 .includes(filterText.toLowerCase())
//                                         )
//                                         : faqs;
//                                 setFilteredQuickReplies(filteredReplies);
//                             } else {
//                                 setShowQuickReply(false);
//                             }
//                         }}
//                         ref={inputRef}
//                         className="form-control me-3"
//                         value={newMessage}
//                         placeholder="Type your message"
//                         onKeyPress={(e) => {
//                             if (e.key === 'Enter') {
//                                 e.preventDefault();
//                                 handleSendMessage(platform);
//                                 setNewMessage('');
//                             }
//                         }}
//                     />
//                     <button
//                         type="submit"
//                         className="btn btn-primary d-flex align-items-center"
//                     >
//                         {(fbSendMessageloading || igSendMessageloading || waSendMessageloading) ? (
//                             <div className="text-center">
//                                 <ThreeDots
//                                     radius="9"
//                                     height="20"
//                                     width="40"
//                                     color="#ffff"
//                                     ariaLabel="three-dots-loading"
//                                     visible={true}
//                                 />
//                             </div>
//                         ) : (
//                             <>
//                                 <svg
//                                     className="icon-20"
//                                     width="18"
//                                     viewBox="0 0 20 21"
//                                     fill="none"
//                                     xmlns="http://www.w3.org/2000/svg"
//                                 >
//                                     <path
//                                         d="M13.8325 6.67463L8.10904 12.4592L1.59944 8.38767C0.66675 7.80414 0.860765 6.38744 1.91572 6.07893L17.3712 1.55277C18.3373 1.26963 19.2326 2.17283 18.9456 3.142L14.3731 18.5868C14.0598 19.6432 12.6512 19.832 12.0732 18.8953L8.10601 12.4602"
//                                         stroke="currentcolor"
//                                         strokeWidth="2"
//                                         strokeLinecap="round"
//                                         strokeLinejoin="round"
//                                     ></path>
//                                 </svg>
//                                 <span className="d-none d-lg-block ms-1">Send</span>
//                             </>
//                         )}
//                     </button>
//                 </form>
//             )}


//             <div>
//                 <Modal size="lg" centered show={show4} onHide={handleClose4}>
//                     <Modal.Header closeButton>
//                         <Modal.Title className="h5">
//                             Send Message to the User
//                         </Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         <Form.Group className="form-group">
//                             <Form.Label>Message Template</Form.Label>
//                             <select
//                                 className="form-select mb-3 shadow-none"
//                                 value={selectedTemplate?._id || ""}
//                                 onChange={handleTemplateChange}
//                             >
//                                 {templates?.map((template) => (
//                                     <option key={template._id} value={template._id}>
//                                         {template?.templateName}
//                                     </option>
//                                 ))}
//                             </select>
//                         </Form.Group>



//                         {selectedTemplate &&
//                             templates
//                                 .find((t) => t._id === selectedTemplate?._id)
//                                 ?.components?.flatMap(
//                                     (component, compIndex) =>
//                                         component.text
//                                             ?.match(/{{\d+}}/g)
//                                             ?.map((placeholder, index) => {
//                                                 const placeholderKey =
//                                                     placeholder.match(/{{(\d+)}}/)[1]; // Extract numeric key
//                                                 return (
//                                                     <Form.Group
//                                                         key={`${compIndex}-${index}`}
//                                                         className="mb-3"
//                                                     >
//                                                         <Form.Label>
//                                                             Parameter ({placeholder}) -{" "}
//                                                             {component.type}
//                                                         </Form.Label>
//                                                         <input
//                                                             type="text"
//                                                             className="form-control"
//                                                             value={
//                                                                 payloadValues[placeholderKey] || ""
//                                                             }
//                                                             onChange={(e) =>
//                                                                 setPayloadValues({
//                                                                     ...payloadValues,
//                                                                     [placeholderKey]: e.target.value,
//                                                                 })
//                                                             }
//                                                             placeholder={`Enter value for ${placeholder}`}
//                                                         />
//                                                     </Form.Group>
//                                                 );
//                                             }) || []
//                                 )}

//                         <Card bg="primary" className="text-white mb-3">
//                             <Card.Body>
//                                 <Card.Title as="h4" className="text-white">
//                                     {selectedTemplate
//                                         ? templates.find(
//                                             (t) => t._id === selectedTemplate?._id
//                                         )?.templateName
//                                         : "No Message Type Selected"}
//                                 </Card.Title>
//                                 <blockquote className="blockquote mb-0">
//                                     <p className="font-size-14">{getUpdatedText()}</p>
//                                 </blockquote>
//                             </Card.Body>
//                         </Card>
//                     </Modal.Body>
//                     <Modal.Footer>
//                         <Button variant="primary" onClick={handleSendMessage}>
//                             Send Message
//                         </Button>
//                     </Modal.Footer>
//                 </Modal>
//             </div>

//                   <div>
//                         <Modal centered show={showMeetModal} onHide={handleCloseMeetModal}>
//                             <Modal.Header closeButton>
//                                 <Modal.Title className='h5'>Generated Meeting Link </Modal.Title>
//                             </Modal.Header>
//                             <Modal.Body>
//                                 {
//                                     !generateMeetingLodading ?
//                                         <>
//                                             <div className='d-flex '>
//                                                 <input
//                                                     type="text"
//                                                     value={meetingLink}
//                                                     readOnly
//                                                     className="form-control border-0 bg-transparent"
//                                                 />
//                                                 <button
//                                                     type="submit"
//                                                     className="btn btn-primary d-flex align-items-center"
//                                                 >
//                                                     <svg
//                                                         className="icon-20"
//                                                         width="18"
//                                                         viewBox="0 0 20 21"
//                                                         fill="none"
//                                                         xmlns="http://www.w3.org/2000/svg"
//                                                     >
//                                                         <path
//                                                             d="M13.8325 6.67463L8.10904 12.4592L1.59944 8.38767C0.66675 7.80414 0.860765 6.38744 1.91572 6.07893L17.3712 1.55277C18.3373 1.26963 19.2326 2.17283 18.9456 3.142L14.3731 18.5868C14.0598 19.6432 12.6512 19.832 12.0732 18.8953L8.10601 12.4602"
//                                                             stroke="currentcolor"
//                                                             strokeWidth="2"
//                                                             strokeLinecap="round"
//                                                             strokeLinejoin="round"
//                                                         ></path>
//                                                     </svg>
//                                                     <span className="d-none d-lg-block ms-1" onClick={handleSendMessage(platform)}>Send</span>
//                                                 </button>
//                                             </div>
//                                         </> : <Oval
//                                             height={30}
//                                             width={30}
//                                             color="#50B5FF"
//                                             secondaryColor="#ccc"
//                                             strokeWidth={4}
//                                             strokeWidthSecondary={2}
//                                             ariaLabel="loading"
//                                         />
//                                 }
//                             </Modal.Body>
//                         </Modal>
//                     </div>

// {/* 
//             <MeetModel
//                 show6={showMeetModal}
//                 handleClose6={handleCloseMeetModal}
//                 senderId={senderId}
//                 link={meetingLink}
//                 platform={platform}
//             /> */}
//         </>
//     );
// };

const ChatInput = ({
    platform,
    hasUserMessages,
    handleClose4,
    handleShow4,
    canSendTemplate,
    handleSendMessage,
    handleSendTemplate,
    setNewMessage,
    newMessage,
    faqs,
    fbSendMessageloading,
    igSendMessageloading,
    waSendMessageloading,
    handleFileUpload,
    setShowEmojiPicker,
    showEmojiPicker,
    setShowQuickReply,
    setFilteredQuickReplies,
    inputRef,
    inputFile

}) => {
    const { profile } = useSelector((state) => state.userservice);
    const dispatch = useDispatch();
    const {
        conversations,
        currentConversation,
        conversationDetails,
        error,
        message,
        loading,
        usergetTemplatesFullfill,
        getTemplatesError,
        getTemplatesByIdFullfill,
        getTemplatesByIdError,
    } = useSelector((state) => state.whatsapp);
    const { generateMeetingLodading } = useSelector((state) => state.google);

    // const inputRef = useRef(null);
    // const inputFile = useRef(null);
    const [showMeetModal, setShowMeetModal] = useState(false);
    const [meetingLink, setMeetingLink] = useState('');
    const [selectedTemplate, setSelectedTemplate] = useState('');
    const [payloadValues, setPayloadValues] = useState([]);
    const [templateData, setTemplateData] = useState('');
    const [templates, setTemplates] = useState([]);
    const [show4, setShow4] = useState(false);
    const [errorMessage, setErrorMessage] = useState(''); // Added for error handling

    console.log(canSendTemplate ,"canSendTemplatecanSendTemplatecanSendTemplatecanSendTemplate")
    // const handleClose4 = () => setShow4(false);
    // const handleShow4 = () => setShow4(true);

    console.log(templates, 'templatestemplatestemplatestemplates');

    useEffect(() => {
        if (platform === 'whatsapp') {
            dispatch(getTemplates());
        }
    }, [platform, dispatch]);

    const onButtonClick = () => {
        inputFile.current.click();
    };

    const getUpdatedText = () => {
        if (!selectedTemplate) return 'No Message Type Selected';

        const template = templates.find((t) => t._id === selectedTemplate?._id);
        if (!template?.components) return 'No Message Type Selected';

        const updatedComponents = template.components.map((component, compIndex) => {
            const textSegments = component.text?.split(/({{\d+}})/g) || [];
            return textSegments.map((segment, index) => {
                const match = segment.match(/{{(\d+)}}/);
                if (match) {
                    const key = parseInt(match[1], 10);
                    const value = key === 1 ? payloadValues[key] || 'test' : payloadValues[key] || '';
                    return <strong key={`${compIndex}-${index}`}>{value}</strong>;
                }
                return segment;
            });
        });

        return updatedComponents.flat();
    };

    const handleTemplateChange = async (event) => {
        const templateId = event.target.value;
        const selected = templates.find((template) => template._id === templateId);
        setSelectedTemplate(selected);
        if (selected) {
            await fetchTemplateData(selected._id);
        }
    };

    const fetchTemplateData = (templateId) => {
        dispatch(getTemplatesById(templateId));
        setTemplateData(getTemplatesByIdFullfill?.template);
        setTemplates(usergetTemplatesFullfill?.template);
    };

    useEffect(() => {
        if (usergetTemplatesFullfill?.template?.length) {
            setTemplates(usergetTemplatesFullfill?.template);
            setSelectedTemplate(usergetTemplatesFullfill?.template[0]);
            fetchTemplateData(usergetTemplatesFullfill?.template[0]?._id);
        }
    }, [usergetTemplatesFullfill]);

    const handleGenerateMeeting = async () => {
        try {
            setShowMeetModal(true);
            setErrorMessage(''); // Clear previous errors
            const resp = await dispatch(generateMeeting());
            const data = resp?.payload;
            if (data?.status === 200 && data?.meetLink) {
                setMeetingLink(data.meetLink);
                setNewMessage(data.meetLink);
            } else {
                setErrorMessage('Failed to generate meeting link. Please try again.');
            }
        } catch (error) {
            console.error('Error generating meeting:', error);
            setErrorMessage('An error occurred while generating the meeting link.');
        }
    };

    const handleCloseMeetModal = () => {
        setShowMeetModal(false);
        setMeetingLink('');
        setErrorMessage('');
    };

    const handlePhoneHover = (show) => {
        if (!profile?.meetLogin) {
            const tooltip = document.getElementById('meet-tooltip');
            if (tooltip) {
                tooltip.style.display = show ? 'block' : 'none';
            }
        }
    };
    return (
        <>
            {platform=== "instagram" &&hasUserMessages === false ? (
                <div className="alert alert-warning w-100 mb-0 d-flex align-items-center justify-content-between p-[14px]">
                    <span>You can no longer reply to this conversation after 7 days of inactivity.</span>
                </div>
            ) :platform==="whatsapp" &&canSendTemplate===true ? (
                <div className="d-flex align-items-center justify-content-center">
                    <Button variant="primary" onClick={handleShow4} className="mt-1">
                        Send Message
                    </Button>
                </div>
            ) : (
                <form
                    className="d-flex align-items-center"
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleSendMessage(platform);
                        setNewMessage('');
                    }}
                >
                    <div className="chat-attagement d-flex">
                        <Link
                            to="#"
                            className="d-flex align-items-center pe-3"
                            onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                        >
                            <svg
                                className="icon-24"
                                width="24"
                                viewBox="0 0 24 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g clipPath="url(#clip0_156_599)">
                                    <path
                                        d="M20.4853 4.01473C18.2188 1.74823 15.2053 0.5 12 0.5C8.79469 0.5 5.78119 1.74823 3.51473 4.01473C1.24819 6.28119 0 9.29469 0 12.5C0 15.7053 1.24819 18.7188 3.51473 20.9853C5.78119 23.2518 8.79469 24.5 12 24.5C15.2053 24.5 18.2188 23.2518 20.4853 20.9853C22.7518 18.7188 24 15.7053 24 12.5C24 9.29469 22.7518 6.28119 20.4853 4.01473ZM12 23.0714C6.17091 23.0714 1.42856 18.3291 1.42856 12.5C1.42856 6.67091 6.17091 1.92856 12 1.92856C17.8291 1.92856 22.5714 6.67091 22.5714 12.5C22.5714 18.3291 17.8291 23.0714 12 23.0714Z"
                                        fill="currentcolor"
                                    />
                                    <path
                                        d="M9.40398 9.3309C8.23431 8.16114 6.33104 8.16123 5.16136 9.3309C4.88241 9.60981 4.88241 10.0621 5.16136 10.3411C5.44036 10.62 5.89266 10.62 6.17157 10.3411C6.78432 9.72836 7.78126 9.7284 8.39392 10.3411C8.53342 10.4806 8.71618 10.5503 8.89895 10.5503C9.08171 10.5503 9.26457 10.4806 9.40398 10.3411C9.68293 10.0621 9.68293 9.60986 9.40398 9.3309Z"
                                        fill="currentcolor"
                                    />
                                    <path
                                        d="M18.8384 9.3309C17.6688 8.16123 15.7655 8.16114 14.5958 9.3309C14.3169 9.60981 14.3169 10.0621 14.5958 10.3411C14.8748 10.62 15.3271 10.62 15.606 10.3411C16.2187 9.72836 17.2156 9.72831 17.8284 10.3411C17.9679 10.4806 18.1506 10.5503 18.3334 10.5503C18.5162 10.5503 18.699 10.4806 18.8384 10.3411C19.1174 10.0621 19.1174 9.60986 18.8384 9.3309Z"
                                        fill="currentcolor"
                                    />
                                    <path
                                        d="M18.3335 13.024H5.6668C5.2723 13.024 4.95251 13.3438 4.95251 13.7383C4.95251 17.6243 8.11409 20.7859 12.0001 20.7859C15.8862 20.7859 19.0477 17.6243 19.0477 13.7383C19.0477 13.3438 18.728 13.024 18.3335 13.024ZM12.0001 19.3573C9.14366 19.3573 6.77816 17.215 6.42626 14.4525H17.574C17.2221 17.215 14.8566 19.3573 12.0001 19.3573Z"
                                        fill="currentcolor"
                                    />
                                </g>
                                <defs>
                                    <clipPath>
                                        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </Link>
                        <Link className="d-flex align-items-center pe-3">
                            <TbFileUpload style={{ fontSize: '25px' }} onClick={onButtonClick} />
                        </Link>
                        {/* <Link
              className="d-flex align-items-center pe-3"
              onClick={handleGenerateMeeting}
              title="Generate Meeting Link"
            >
              <TbPhone style={{ fontSize: '25px', cursor: 'pointer' }} />
            </Link> */}
                        <div
                            className="position-relative"
                            onMouseEnter={() => handlePhoneHover(true)}
                            onMouseLeave={() => handlePhoneHover(false)}
                        >
                            <Link
                                className={`d-flex align-items-center pe-3 ${!profile?.meetLogin ? 'disabled-link' : ''}`}
                                onClick={profile?.meetLogin ? handleGenerateMeeting : undefined}
                                title={profile?.meetLogin ? "Generate Meeting Link" : ""}
                                style={{
                                    cursor: profile?.meetLogin ? 'pointer' : 'not-allowed',
                                    opacity: profile?.meetLogin ? 1 : 0.5
                                }}
                            >
                                <TbPhone
                                    style={{ fontSize: '25px' }}
                                />
                            </Link>
                            {
                                !profile?.meetLogin && (
                                    <div
                                        className="position-absolute bg-dark text-white p-2 rounded shadow-lg"
                                        style={{
                                            bottom: '100%',
                                            left: '50%',
                                            transform: 'translateX(-50%)',
                                            marginBottom: '8px',
                                            minWidth: '200px',
                                            zIndex: 1000,
                                            fontSize: '12px',
                                            display: 'none'
                                        }}
                                        id="meet-tooltip"
                                    >
                                        <div className="mb-2">
                                            If you need to use call feature, please connect Google Meet
                                        </div>
                                        <Link to="/settings" passHref>
                                            <button className="btn btn-sm btn-primary w-100">
                                                Go to settings
                                            </button>
                                        </Link>
                                        <div
                                            className="position-absolute"
                                            style={{
                                                top: '100%',
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                                width: 0,
                                                height: 0,
                                                borderLeft: '6px solid transparent',
                                                borderRight: '6px solid transparent',
                                                borderTop: '6px solid #212529'
                                            }}
                                        ></div>
                                    </div>
                                )
                            }
                        </div>
                        <input
                            style={{ display: 'none' }}
                            ref={inputFile}
                            onChange={handleFileUpload}
                            type="file"
                        />
                    </div>
                    <input
                        type="text"
                        onChange={async (e) => {
                            const value = e.target.value;
                            setNewMessage(value);
                            if (value.startsWith('/')) {
                                setShowQuickReply(true);
                                const filterText = value.slice(1);
                                const filteredReplies = filterText.length > 0
                                    ? faqs?.filter((faq) => faq?.title?.toLowerCase().includes(filterText.toLowerCase()))
                                    : faqs;
                                setFilteredQuickReplies(filteredReplies);
                            } else {
                                setShowQuickReply(false);
                            }
                        }}
                        ref={inputRef}
                        className="form-control me-3"
                        value={newMessage}
                        placeholder="Type your message"
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleSendMessage(platform);
                                setNewMessage('');
                            }
                        }}
                    />
                    <button type="submit" className="btn btn-primary d-flex align-items-center">
                        {(fbSendMessageloading || igSendMessageloading || waSendMessageloading) ? (
                            <div className="text-center">
                                <ThreeDots
                                    radius="9"
                                    height="20"
                                    width="40"
                                    color="#ffff"
                                    ariaLabel="three-dots-loading"
                                    visible={true}
                                />
                            </div>
                        ) : (
                            <>
                                <svg
                                    className="icon-20"
                                    width="18"
                                    viewBox="0 0 20 21"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M13.8325 6.67463L8.10904 12.4592L1.59944 8.38767C0.66675 7.80414 0.860765 6.38744 1.91572 6.07893L17.3712 1.55277C18.3373 1.26963 19.2326 2.17283 18.9456 3.142L14.3731 18.5868C14.0598 19.6432 12.6512 19.832 12.0732 18.8953L8.10601 12.4602"
                                        stroke="currentcolor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                <span className="d-none d-lg-block ms-1">Send</span>
                            </>
                        )}
                    </button>
                </form>
            )}

            {/* <Modal
                size="lg"
                centered
                show={show4}
                onHide={handleClose4}
                className="fade"
                dialogClassName=" rounded-2xl max-w-2xl transform transition-all duration-300"
            >
                <Modal.Header className="bg-[#50B5FF] text-white p-6 rounded-t-2xl border-0 flex justify-between items-center">
                    <Modal.Title className="h5 text-white font-semibold">Send Message to the User</Modal.Title>
                    <button
                        onClick={handleClose4}
                        className="text-white hover:bg-white hover:bg-opacity-20 p-2 rounded-full transition-colors duration-200"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </Modal.Header>
                <Modal.Body className="p-6 space-y-6">
                    <Form.Group>
                        <Form.Label className="text-sm font-medium text-gray-700">Message Template</Form.Label>
                        <select
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#50B5FF] focus:border-transparent transition-all duration-200 shadow-sm bg-white"
                            value={selectedTemplate?._id || ""}
                            onChange={handleTemplateChange}
                        >
                            <option value="">Select a template</option>
                            {templates?.map((template) => (
                                <option key={template._id} value={template._id}>
                                    {template?.templateName}
                                </option>
                            ))}
                        </select>
                    </Form.Group>

                    {selectedTemplate &&
                        templates
                            .find((t) => t._id === selectedTemplate?._id)
                            ?.components?.flatMap(
                                (component, compIndex) =>
                                    component.text
                                        ?.match(/{{\d+}}/g)
                                        ?.map((placeholder, index) => {
                                            const placeholderKey = placeholder.match(/{{(\d+)}}/)[1];
                                            return (
                                                <Form.Group key={`${compIndex}-${index}`} className="mb-4">
                                                    <Form.Label className="text-sm font-medium text-gray-700">
                                                        Parameter ({placeholder}) - {component.type}
                                                    </Form.Label>
                                                    <input
                                                        type="text"
                                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#50B5FF] focus:border-transparent transition-all duration-200 shadow-sm"
                                                        value={payloadValues[placeholderKey] || ""}
                                                        onChange={(e) =>
                                                            setPayloadValues({
                                                                ...payloadValues,
                                                                [placeholderKey]: e.target.value,
                                                            })
                                                        }
                                                        placeholder={`Enter value for ${placeholder}`}
                                                    />
                                                </Form.Group>
                                            );
                                        }) || []
                            )}

                    <Card className="bg-[#50B5FF] bg-opacity-90 text-white rounded-xl shadow-md">
                        <Card.Body className="p-4">
                            <Card.Title as="h4" className="text-white font-semibold mb-2">
                                {selectedTemplate
                                    ? templates.find((t) => t._id === selectedTemplate?._id)?.templateName
                                    : "No Message Type Selected"}
                            </Card.Title>
                            <blockquote className="blockquote mb-0">
                                <p className="text-gray-100 text-base">{getUpdatedText()}</p>
                            </blockquote>
                        </Card.Body>
                    </Card>
                </Modal.Body>
                <Modal.Footer className="bg-gray-50 p-6 rounded-b-2xl border-0 flex justify-end space-x-4">
                    <Button
                        variant="outline-secondary"
                        onClick={handleClose4}
                        className="px-6 py-2 rounded-lg font-medium text-gray-700 hover:bg-gray-200 transition-all duration-200 shadow-sm"
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() => handleSendMessage(platform)}
                        className="px-6 py-2 bg-[#50B5FF] text-white rounded-lg font-medium hover:bg-[#50B5FF]-600 transition-all duration-200 shadow-md hover:shadow-lg"
                    >
                        Send Message
                    </Button>
                </Modal.Footer>
            </Modal> */}
            {/* <Modal size="lg" centered show={show4} onHide={handleClose4}>
                <Modal.Header closeButton>
                    <Modal.Title className="h5">Send Message to the User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="form-group">
                        <Form.Label>Message Template</Form.Label>
                        <select
                            className="form-select mb-3 shadow-none"
                            value={selectedTemplate?._id || ''}
                            onChange={handleTemplateChange}
                        >
                            {templates?.map((template) => (
                                <option key={template._id} value={template._id}>
                                    {template?.templateName}
                                </option>
                            ))}
                        </select>
                    </Form.Group>

                    {selectedTemplate &&
                        templates
                            .find((t) => t._id === selectedTemplate?._id)
                            ?.components?.flatMap((component, compIndex) =>
                                component.text
                                    ?.match(/{{\d+}}/g)
                                    ?.map((placeholder, index) => {
                                        const placeholderKey = placeholder.match(/{{(\d+)}}/)[1];
                                        return (
                                            <Form.Group key={`${compIndex}-${index}`} className="mb-3">
                                                <Form.Label>
                                                    Parameter ({placeholder}) - {component.type}
                                                </Form.Label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={payloadValues[placeholderKey] || ''}
                                                    onChange={(e) =>
                                                        setPayloadValues({
                                                            ...payloadValues,
                                                            [placeholderKey]: e.target.value,
                                                        })
                                                    }
                                                    placeholder={`Enter value for ${placeholder}`}
                                                />
                                            </Form.Group>
                                        );
                                    }) || []
                            )}

                    <Card bg="primary" className="text-white mb-3">
                        <Card.Body>
                            <Card.Title as="h4" className="text-white">
                                {selectedTemplate
                                    ? templates.find((t) => t._id === selectedTemplate?._id)?.templateName
                                    : 'No Message Type Selected'}
                            </Card.Title>
                            <blockquote className="blockquote mb-0">
                                <p className="font-size-14">{getUpdatedText()}</p>
                            </blockquote>
                        </Card.Body>
                    </Card>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleSendMessage}>
                        Send Message
                    </Button>
                </Modal.Footer>
            </Modal> */}

            <Modal
                centered
                show={showMeetModal}
                onHide={handleCloseMeetModal}
                className="fade"
                dialogClassName=" rounded-2xl max-w-md transform transition-all duration-300"
            >
                <Modal.Header className="bg-[#50B5FF] text-white p-6 rounded-t-2xl border-0 flex justify-between items-center">
                    <Modal.Title className="h5 text-white font-semibold">Generated Meeting Link</Modal.Title>
                    <button
                        onClick={handleCloseMeetModal}
                        className="text-white hover:bg-white hover:bg-opacity-20 p-2 rounded-full transition-colors duration-200"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </Modal.Header>
                <Modal.Body className="p-6 text-center">
                    {generateMeetingLodading ? (
                        <div className="flex justify-center">
                            <Oval
                                height={40}
                                width={40}
                                color="#50B5FF"
                                secondaryColor="#ccc"
                                strokeWidth={4}
                                strokeWidthSecondary={2}
                                ariaLabel="loading"
                            />
                        </div>
                    ) : errorMessage ? (
                        <div className="bg-red-100 text-red-700 p-4 rounded-lg">{errorMessage}</div>
                    ) : (
                        <div className="flex items-center justify-center space-x-4">
                            <input
                                type="text"
                                value={meetingLink}
                                readOnly
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-[#50B5FF] focus:border-transparent transition-all duration-200"
                                placeholder="No meeting link generated"
                            />
                            <button
                                type="button"
                                className="btn btn-primary px-4 py-2 bg-[#50B5FF] text-white rounded-lg hover:bg-[#50B5FF]-600 transition-all duration-200 shadow-md flex items-center space-x-2"
                                onClick={() => {
                                    handleSendMessage(platform)
                                    handleCloseMeetModal()
                                }}
                                disabled={!meetingLink}
                            >
                                <svg
                                    className="w-5 h-5"
                                    width="18"
                                    viewBox="0 0 20 21"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M13.8325 6.67463L8.10904 12.4592L1.59944 8.38767C0.66675 7.80414 0.860765 6.38744 1.91572 6.07893L17.3712 1.55277C18.3373 1.26963 19.2326 2.17283 18.9456 3.142L14.3731 18.5868C14.0598 19.6432 12.6512 19.832 12.0732 18.8953L8.10601 12.4602"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                <span className="ml-2">Send</span>
                            </button>
                        </div>
                    )}
                </Modal.Body>
            </Modal>

            {/* <Modal centered show={showMeetModal} onHide={handleCloseMeetModal}>
                <Modal.Header closeButton>
                    <Modal.Title className="h5">Generated Meeting Link</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {generateMeetingLodading ? (
                        <div className="text-center">
                            <Oval
                                height={30}
                                width={30}
                                color="#50B5FF"
                                secondaryColor="#ccc"
                                strokeWidth={4}
                                strokeWidthSecondary={2}
                                ariaLabel="loading"
                            />
                        </div>
                    ) : errorMessage ? (
                        <div className="alert alert-danger">{errorMessage}</div>
                    ) : (
                        <div className="d-flex align-items-center">
                            <input
                                type="text"
                                value={meetingLink}
                                readOnly
                                className="form-control border-0 bg-transparent"
                                placeholder="No meeting link generated"
                            />
                            <button
                                type="button"
                                className="btn btn-primary d-flex align-items-center ms-2"
                                onClick={() => handleSendMessage(platform)}
                                disabled={!meetingLink}
                            >
                                <svg
                                    className="icon-20"
                                    width="18"
                                    viewBox="0 0 20 21"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M13.8325 6.67463L8.10904 12.4592L1.59944 8.38767C0.66675 7.80414 0.860765 6.38744 1.91572 6.07893L17.3712 1.55277C18.3373 1.26963 19.2326 2.17283 18.9456 3.142L14.3731 18.5868C14.0598 19.6432 12.6512 19.832 12.0732 18.8953L8.10601 12.4602"
                                        stroke="currentcolor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                <span className="d-none d-lg-block ms-1">Send</span>
                            </button>
                        </div>
                    )}
                </Modal.Body>
            </Modal> */}
        </>
    );
};
export default ChatInput;